// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__30tJ-","search":"Settings_search__3kCnT","filter":"Settings_filter__1UZ9s"};